import { HomePostsItemController } from './home-posts-item.controller'

function homePostsItem () {
  return {
    restrict: 'E',
    scope: {
      post: '<'
    },
    templateUrl: '/home/directives/home-posts-item/home-posts-item-directive.html?$$REVISION$$',
    controller: HomePostsItemController
  }
}

export { homePostsItem }
